import { coreActions } from '@sonar-software/sonar-core';
import { LocalStorageKey } from '@sonar-software/sonar-ts-types';
import { SyncView } from './general';
import { Button, Space } from 'antd';
import { ONBOARDING_CONNECT_COPY, ONBOARDING_SYNC_COPY } from '@sonar-software/sonar-ts-constants';
import React, { useCallback } from 'react';
import { useAction, useOnboardingProgress, useOrganizations, useSwitchOrganization } from '@hooks';
export const SyncOrganizationView = () => {
    const organizations = useOrganizations();
    const switchOrganization = useSwitchOrganization();
    const { progress, updateProgress } = useOnboardingProgress();
    const refreshOrgs = useAction(coreActions.requestGetCoreOrganizationsAll);
    const handleReturn = useCallback(() => {
        var _a, _b;
        refreshOrgs();
        const lastUsedOrgId = localStorage.getItem(LocalStorageKey.LastUsedOrg);
        if (lastUsedOrgId && !isNaN(Number(lastUsedOrgId))) {
            localStorage.removeItem(LocalStorageKey.LastUsedOrg);
            switchOrganization({ organizationId: Number(lastUsedOrgId) });
        }
        else {
            const targetOrganizationId = (_a = progress === null || progress === void 0 ? void 0 : progress.organizationId) !== null && _a !== void 0 ? _a : (_b = organizations === null || organizations === void 0 ? void 0 : organizations.filter((org) => org.hasSalesforceData)[0]) === null || _b === void 0 ? void 0 : _b.id;
            switchOrganization({
                organizationId: targetOrganizationId
            });
        }
        updateProgress({
            isSalesforceConnected: true,
            isSalesforceSynced: true
        });
    }, [organizations, progress === null || progress === void 0 ? void 0 : progress.organizationId, refreshOrgs, switchOrganization, updateProgress]);
    return (React.createElement(SyncView, { title: ONBOARDING_SYNC_COPY.SYNCING_ORG },
        React.createElement(Space, { align: 'center', className: 'button-wrapper' },
            React.createElement(Button, { onClick: handleReturn, type: 'primary' }, ONBOARDING_CONNECT_COPY.RETURN_TO_DASHBOARD))));
};
